import CubicBezier from './cubicBezier';

var isPlaying = false;
var rafQueue = []
function removeFromRaf(animation) {
    for (let i=0; i<rafQueue.length; i++) {
        if (rafQueue[i] == animation) {
            rafQueue.splice(i,1)
            break;
        }
    }
}
function addToRaf(animation) {
    let isInRaf = false
    rafQueue.forEach((anim)=>{
        if (anim == animation) {
            isInRaf = true
        }
    })  
    if (!isInRaf) {
        rafQueue.push( animation )
    } 
}

function update() {
    requestAnimationFrame(update)
    rafQueue.forEach((anim)=>{
        anim && anim.update()
    });
}

export default class WebAnimation {
    constructor(options) {
        this.step      = options.step || function(){}
        this.end       = options.end || function(){}
        this.direction = options.direction || 1;
        this.duration  = options.duration || 1000;
        this.easing    = options.easing || [0.550, 0.085, 0.680, 0.530];
        this.delay     = options.delay  || 0;
        this._progress = 0;
        this._easedProgress = 0;
    }
    destroy() {
        removeFromRaf(this)
    }
    play() {
        this.delayProgress  = 0;
        this._progress      = this.direction == 1 ? 0 : 1
        this._easedProgress = this.direction == 1 ? 0 : 1
        this.isPlaying      = true;
        addToRaf(this)
        if (!isPlaying) {
            isPlaying = true;
            update()
        }
    }
    pause() {
        clearTimeout(this._delayTimer)
        this.isPlaying = false;
    }
    reset() {
        this._progress = 0;
    }
    update() {
        
        if (this.isPlaying) {  

            if (this.delayProgress<this.delay) {
                this.delayProgress  += (1000/60)
                return;
            }

            this._progress += (1 / (this.duration / (1000/60))) * this.direction;
            this._easedProgress = CubicBezier(
                this.easing[0],
                this.easing[1], 
                this.easing[2], 
                this.easing[3], 
                Math.max(0, Math.min(1, this._progress)),
                1
            );
           
            if ( (this.direction == 1 && this._easedProgress < 1) || 
                 (this.direction == -1 && this._easedProgress > 0)    ) {            
                this.step( this._easedProgress , this._progress);
            }
            else {
                this.isPlaying = false;
                this._progress      = this.direction == 1 ? 1 : 0;
                this._easedProgress =  this.direction == 1 ? 1 : 0;
                this.step( this._easedProgress , this._progress);
                this.end();
            }
            
        }
    }
}
